import {
  useGetSalesFunnelListOnMount,
  useGetAllFunnelStagesOnMount,
} from '@user/store/salesFunnel'
import { useGetDivisionsOnMount } from '@user/store/divisions'
import { useGetLocationTypesOnMount } from '@user/store/locationTypes'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam'
import { useGetTargetPestsOnMount } from '@user/store/targetPests'
import { useGetSourcesOnMount } from '@user/store/sources'
import { useGetCampaignsOnMount } from '@user/store/campaigns'
import { useGetSalesTeamPositionsData } from '@user/store/authorization'
import { useGetCustomFieldsOnMount } from '@user/store/customFields'
import { useGetEntityFormSettingsOnMount } from '@user/store/entityFormSettings'
import { useGetCustomFieldsSettingsOnMount } from '@user/store/customFieldSettings'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetDraftLeadOnMount } from '@user/store/draftLeads'

export const useGetAddLeadDataOnMount = (draftLeadId?: string | null) => {
  const [draftLoading, draft] = useGetDraftLeadOnMount(draftLeadId)

  const teamStatus = useGetSalesTeamListOnMount({
    includeTeamsByBranchId: true,
  })
  const funnelStatus = useGetSalesFunnelListOnMount()
  const stageStatus = useGetAllFunnelStagesOnMount()
  const divisionStatus = useGetDivisionsOnMount()
  const locationTypeStatus = useGetLocationTypesOnMount()
  const targetPestStatus = useGetTargetPestsOnMount()
  const sourceStatus = useGetSourcesOnMount()
  const campaignStatus = useGetCampaignsOnMount()
  const positionsDataStatus = useGetSalesTeamPositionsData()
  const customFieldsLoading = useGetCustomFieldsOnMount()
  const { loading: entityFormSettingsStatus } = useGetEntityFormSettingsOnMount(
    ENTITY_TYPES.Lead,
  )
  const { loading: loadingCustomSettings } = useGetCustomFieldsSettingsOnMount(
    ENTITY_TYPES.Lead,
  )

  const loading =
    funnelStatus == 'pending' ||
    stageStatus == 'pending' ||
    teamStatus == 'pending' ||
    divisionStatus == 'pending' ||
    locationTypeStatus == 'pending' ||
    targetPestStatus == 'pending' ||
    sourceStatus == 'pending' ||
    campaignStatus == 'pending' ||
    positionsDataStatus == 'pending' ||
    customFieldsLoading ||
    entityFormSettingsStatus ||
    loadingCustomSettings ||
    draftLoading

  return { loading, draft }
}
